import { ETrueFalse } from 'enums/trueFalse';

const jeStatutarSelect = [
    {
        value: ETrueFalse.TRUE,
        labelcz: 'FORMULARE_AMLZ_C4_OSOBA_TRUE'
    },
    {
        value: ETrueFalse.FALSE,
        labelcz: 'FORMULARE_AMLZ_C4_OSOBA_FALSE'
    }
];

export default jeStatutarSelect;
